import { Link } from 'react-router-dom';
import Logo from './Logo';
import { SITE } from '@/lib/site';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-bg-surface">
      <div className="mx-auto max-w-page px-5 py-12 sm:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Logo />
            <p className="mt-4 max-w-sm text-sm text-fg-muted">
              {SITE.tagline}. We build and host websites that are fast,
              accessible, and properly looked after.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-fg-subtle">
              Site
            </h4>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link className="text-fg-muted hover:text-fg-base" to="/">Home</Link></li>
              <li><Link className="text-fg-muted hover:text-fg-base" to="/about">About</Link></li>
              <li><Link className="text-fg-muted hover:text-fg-base" to="/contact">Contact</Link></li>
              <li><Link className="text-fg-muted hover:text-fg-base" to="/privacy">Privacy</Link></li>
              <li><Link className="text-fg-muted hover:text-fg-base" to="/terms">Terms</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-fg-subtle">
              Get in touch
            </h4>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <a className="text-fg-muted hover:text-fg-base" href={SITE.phoneHref}>
                  {SITE.phone}
                </a>
              </li>
              <li>
                <a
                  className="text-fg-muted hover:text-fg-base"
                  href={`mailto:${SITE.email}`}
                >
                  {SITE.email}
                </a>
              </li>
              <li>
                <Link className="link" to="/contact">
                  Start a project →
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-border pt-6 text-xs text-fg-subtle sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {SITE.name}. All rights reserved.</p>
          <p>Built and hosted in the UK.</p>
        </div>
      </div>
    </footer>
  );
}
